import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useLocalizationEnabled() {
  const localization = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.Localization),
  )

  return localization?.enabled ?? false
}
